<light-layout>
    <div class="__page-root">
        <hero name="Capital One" kicker="Salesforce Data Load Automation.">
            <div class="cover-image hero-background tinted"></div>
            <back-to-button></back-to-button>
        </hero>
        <div class="sections">
            <app-summary
                color="#0e414c"
                content="Our client is a major credit card company recognized around the world that holds a coveted spot on the Fortune 500 list.">
                <role [style.width.%]="100">
                    <li>Spring</li>
                    <li>Spring Boot</li>
                    <li>REST</li>
                    <li>Gradle</li>
                    <li>JIRA</li>
                    <li>CICD</li>
                    <li>Eclipse</li>
                    <li>Chef</li>
                    <li>Jenkins</li>
                    <li>Amazon Lambda</li>
                    <li>AWS SWF, EC2, S3, RDS, CloudFormation</li>
                </role>
            </app-summary>
            <challenge
                color="#0e414c"
                content="To automate data load into Salesforce using Java/JEE and replace the legacy manual process."></challenge>
            <solution-header content="microservices architecture solution with salesforce"></solution-header>
            <solution>
                <p>Data Concepts built a solution for the Investments Line Of Business to automate data load into the Salesforce instance using Java/JEE as the underlying programming language. This solution automates the loading of referral data from Touchpoint application into their Salesforce instance, and replaces the current manual process. The solution has been developed as a framework so that it can be extended for other business use cases. Data Concepts stood up the AWS Cloud environment from scratch. The technology stack for the solution includes AWS Cloud – Lambda, SWF, S3, RDS, & EC2 Services; Spring Boot Microservices Architecture, Java/JEE along with Jenkins/Gradle for the CICD piece.</p>
                <ul class="pseudo">
                    <li>- Data Concepts built a microservices architecture solution to automate data load into the Salesforce instance on an AWS environment designed and architected from scratch.</li>
                    <li>- The solution automates the loading of referral data from Touchpoint application into the Salesforce instance replacing the current manual process.</li>
                    <li>- The solution has been developed as a framework that can be extended for other business use cases.</li>
                </ul>
            </solution>
            <outcome
                color="#0e414c"
                content="Data Concepts developed an automation process into Salesforce, using JEE technologies for Capital One Investments; we stood up the AWS Cloud Environment from scratch."></outcome>
        </div>
    </div>
</light-layout>
